import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';
import type { CreatePimsConfigPayload } from '@v2/types';

interface UseCreatePimsConfigResult {
  createConfig: (payload: CreatePimsConfigPayload) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useCreatePimsConfig = (): UseCreatePimsConfigResult => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: pimsService.createConfig,
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.detail(payload.entityId) });
      queryClient.invalidateQueries({
        queryKey: queryKeys.configurations.byPims(payload.entityId),
      });
    },
  });

  return {
    createConfig: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreatePimsConfig;
